import { cn } from '@saas-pages/shared/ui'
import { LOCALES, useLocale, useT, type Locale } from '@/shared/i18n'

const LABEL: Record<Locale, string> = {
  ru: 'RU',
  en: 'EN',
}

export function LangSwitcher() {
  const t = useT()
  const { locale, setLocale } = useLocale()

  return (
    <div
      role="group"
      aria-label={t.langSwitcher.aria}
      className="flex items-center gap-0.5 rounded-md border bg-card p-0.5"
    >
      {LOCALES.map((item) => {
        const selected = item === locale
        return (
          <button
            key={item}
            type="button"
            onClick={() => setLocale(item)}
            aria-pressed={selected}
            className={cn(
              'rounded px-2 py-0.5 text-xs font-medium transition-colors',
              selected
                ? 'bg-accent text-foreground'
                : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
            )}
          >
            {LABEL[item]}
          </button>
        )
      })}
    </div>
  )
}
